import React from 'react';
import MessageBubble from './MessageBubble';
import ChatIcon from './chat.svg';
import UserName from '../../../../elements/UserName';
import MeetingUserName from './MeetingUserName';

function MeetingInvite(props) {
    const { meeting } = props,
        { initiator } = meeting;

    return (
        <MessageBubble icon={<ChatIcon />} name={<MeetingUserName meeting={meeting} user={initiator} />}>
            {meeting.details}
        </MessageBubble>
    );
}

export default MeetingInvite;
